import { createStore } from 'vuex'

export default createStore({
  state: {
    navigationDrawer: false,
    menus: [],          // populated on app mount from API
    menusLoaded: false,
  },
  mutations: {
    SET_MENUS(state, menus) {
      state.menus = menus
      state.menusLoaded = true
    },
    SET_DRAWER(state, val) {
      state.navigationDrawer = val
    },
  },
  actions: {
    async fetchMenus({ commit, state }) {
      if (state.menusLoaded) return
      try {
        const { APIService } = await import('../Utils/APIService')
        const api = new APIService()
        const res = await api.getMenus()
        if (res.status === 200) {
          commit('SET_MENUS', res.data.data || [])
        }
      } catch (_) { /* silently fail – hardcoded nav already shown */ }
    },
  },
})
